import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { BaseIncidentFields } from './common';

export enum KeyType {
  APARTMENT = 'APARTMENT_KEY',
  COMMON = 'COMMON_KEY',
}

export interface OrderNewKeyRequest extends BaseIncidentFields {
  title?: string;
  description?: string;
  keyType: KeyType;
  quantity: number;
  classification: IncidentClassification;
  subClassification: IncidentSubClassification;
}
